import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { EventCustomerBillingDTO } from '../../../dto/event/event-customer-billing.dto';

@Component({
  selector: 'app-duna-customers-participants-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatListModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>
      Deltagere – {{ data.row.event_name || data.row.guid }}
    </h2>
    <mat-dialog-content>
      <p class="summary">
        <strong>Kunde:</strong> {{ data.row.customer.name }}<br />
        <strong>Pris pr. deltager:</strong>
        {{ data.row.price.toLocaleString('da-DK') }} kr.<br />
        <strong>Antal fakturerede deltagere:</strong>
        {{ data.row.participant_count ?? 0 }}<br />
        <strong>Total:</strong>
        {{ data.row.total_price.toLocaleString('da-DK') }} kr. @if
        (data.row.extra_amount != null) { +
        {{ data.row.extra_amount!.toLocaleString('da-DK') }} kr. ekstra @if
        (data.row.extra_amount_comment) { ({{ data.row.extra_amount_comment }})
        } }
      </p>
      <p class="hint">
        Tæller kun deltagere med status <em>shownup</em> eller
        <em>completed</em>, ekskl. instructors.
      </p>
      @if (data.row.participants && data.row.participants.length > 0) {
      <mat-list>
        @for (p of data.row.participants; track p) {
        <mat-list-item>
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>{{ p.name }}</span>
        </mat-list-item>
        }
      </mat-list>
      } @else {
      <p class="no-participants">Ingen fakturerede deltagere fundet.</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button (click)="dialogRef.close()">Luk</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .summary {
        line-height: 1.8;
      }
      .hint {
        font-size: 0.8rem;
        color: #666;
        margin-top: 8px;
      }
      .no-participants {
        color: #888;
        font-style: italic;
      }
      mat-dialog-content {
        min-width: 400px;
        max-height: 60vh;
      }
    `,
  ],
})
export class DunaCustomersParticipantsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DunaCustomersParticipantsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { row: EventCustomerBillingDTO }
  ) {}
}
